import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7001Model } from '../kymw7001.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { SelectionListInfo } from '../vo/selection-list-info.model';

/**
 * 表紙特集商品選定情報承認サービス
 * @export ApprovalFeatureInfoService
 * @class ApprovalFeatureInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class ApprovalFeatureInfoService extends PlessJsonResponderSub<null> {
  model: KYMW7001Model;
  buyerList: string[];
  chkSelectionList: SelectionListInfo[];
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof ApprovalFeatureInfoService
   */
  private getBody(): PlessRequest {

    const selectionList = {
      SelectionList: {
        condition: {
          OrderCode: this.model.orderCode,
          MediumType: this.model.mediumType,
          FeatureCode: this.model.featureCode,
        },
        combination: this.chkSelectionList.map(item => ({
          condition: {
            PCode: item.pCode,
            ItemCode: item.itemCode,
            ItemFeatureCode: item.featureCode
          },
          parameter: {
            PricePattern: item.pricePattern,
            ThisTimeSupplyPrice: item.thisTimeSupplyPrice,
            ThisTimeCostPrice: item.thisTimeCostPrice,
            PlanNum: item.planNum,
            PlanSupplyBudget: item.planSupplyBudget,
          }
        }))
      }
    }
    const buyerCodeList = {
      BuyerCodeList: {
        combination: this.buyerList.map(item => ({
          condition: {
            BuyerCode: item
          } 
        }))
      }
    }

    const updateObj = {
      update:{
        SelectionList: selectionList.SelectionList,
        BuyerCodeList: buyerCodeList.BuyerCodeList
      }
    }

    return new PlessRequest(updateObj);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof ApprovalFeatureInfoService
   */
  execute(model: KYMW7001Model, buyerList: string[], chkSelectionList: SelectionListInfo[], f?: () => void): void {
    this.model = model;
    this.buyerList = buyerList;
    this.chkSelectionList = chkSelectionList;
    if (f) this.calbak = f;
    this.send('approvalFeatureInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof ApprovalFeatureInfoService
   */
  success() {
    this.dialogService.openAlertGetMessage('I0508', ['承認']);
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    this.dialogService.openAlertGetMessage('E0574', ['承認']);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    this.dialogService.openAlertGetMessage('E0574', ['承認']);
  }
}
